import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminPagesService, returnPageDetails, useReturnAdminPagesList } from './adminPagesSlice'
import PageHeadSection from './components/PageHeadSection'
import AlertElement from '../../components/AlertElement'
import GridData from '../../components/GridData/GridData'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import { IAdminPage } from './Interfaces'

interface IProps {
    hidePageHeadSection?: boolean,
    hidSectionBox?: boolean,
}

export default function AdminGridDataBasePage(props: IProps) {

    const { hidePageHeadSection, hidSectionBox } = props

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [error, setError] = useState<string>("")

    const params = useParams()
    const pageName = params.page_name ? params.page_name : ""

    const [page, setPage] = useState<IAdminPage>(AdminPagesService.usePageDetails(pageName))
    const pages = useReturnAdminPagesList()

    const appClass = page.appClass

    /**
     * Validate
     */
    useEffect(() => {

        // App class
        if (!appClass){
            setError("App Class is not set!")
        }

        if (!appClass?.gridDataColumns){
            setError("Grid Data colums are not set!")
        }

        if (!appClass?.dynamicBasePage){
            setError("Dynamic Base Page is not set")
        }

        if (!appClass?.gridDataEssentials){
            setError("gridDataEssentials is missing")
        }

    }, [])

    useEffect(() => {
        if (pageName !== page.name){
            setPage(returnPageDetails(pageName, pages))
            console.log("pageName", pageName, "page", page)
        }
    }, [pageName])

    /**
     * Error
     */
    if (error){
        return <AlertElement type="error" message={error} />
    }

    /**
     * Grid
     */
    const renderDataGrid = () => {
        if (!appClass){
            return;
        }

        if (!appClass.dynamicBasePage){
            return "Error: appClass.dynamicBasePage";
        }

        if (!appClass.gridDataEssentials){
            return "Error: !appClass.gridDataEssentials";
        }

        if (!appClass.gridDataColumns){
            return "Error: !appClass.gridDataColumns";
        }

        if (!appClass.gridConfig){
            return "Error: !appClass.gridConfig";
        }

        if (!appClass.dynamicBasePage.updateSearch){
            return "Error: !appClass.dynamicBasePage.updateSearch";
        }

        const items = appClass.dynamicBasePage.items()
        const selectedItems = appClass.gridDataEssentials.selectedItems()
        const pagination = appClass.dynamicBasePage.pagination()
        const search = appClass.dynamicBasePage.search()
        const searchParams = appClass.gridDataEssentials.searchParams()
        const loading = appClass.dynamicBasePage.loading()

        return(
            <GridData 
                items={items}
                columns={appClass.gridDataColumns}
                selectedItems={selectedItems}
                pagination={pagination}
                search={search ? search : ""}
                searchParams={searchParams}
                loading={loading}
                actionButtons={appClass.gridDataEssentials.actionButtons}
                headerOptions={appClass.gridDataEssentials.headerOptions}
                handleLoadItems={appClass.listOfInstances}
                updateSearch={(search) => {
                    if (appClass.dynamicBasePage?.updateSearch){
                        appClass.dynamicBasePage.updateSearch(search, dispatch)
                    }
                }}
                setSelectedItems={(items) => {
                    if (appClass.gridDataEssentials?.setSelectedItems){
                        appClass.gridDataEssentials?.setSelectedItems(items, dispatch)
                    }
                }}
                onDeleteItem={(id) => appClass.deleteInstance(id)}
                onDeleteManyItems={(records) => appClass.deleteManyInstances(records)}
                deleteItem={(id, dispatch) => appClass.dynamicBasePage?.deleteItem(id, dispatch)}
                updateLoading={(status) => appClass.dynamicBasePage?.updateLoadingStatus(status, dispatch)}
                updateItemSearchParams={(params) => appClass.gridDataEssentials?.updateItemSearchParams(params, dispatch)}
                addNewItem={(item, dispatch) => appClass.dynamicBasePage?.addNewItem(item, dispatch)}
                updateItem={(item, dispatch) => appClass.dynamicBasePage?.updateItem(item, dispatch)}
                updateAllItems={(items, dispatch) => appClass.dynamicBasePage?.updateAllItems(items, dispatch)}
                updateItemsPagination={(pagination, dispatch) => appClass.dynamicBasePage?.updateItemsPagination(pagination, dispatch)}
                // updateSearchParamsBeforeLoadItems={(params) => {
                //     if (appClass.gridDataEssentials?.updateSearchParamsBeforeLoadItems){
                //         appClass.gridDataEssentials?.updateSearchParamsBeforeLoadItems(params, dispatch)
                //     }
                // }}

                config={appClass.gridConfig}
                nothingFoundMessage={appClass.messages.nothingFound}
            />
        )
    }

    return(
        <div>
            {!hidePageHeadSection && <PageHeadSection pageName={pageName} />}

            
           
           {hidSectionBox ? renderDataGrid() : <SectionBoxContainer>{renderDataGrid()}</SectionBoxContainer>}
        </div>
    )
}